<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">{{ data.isCancelar ? 'flag' : 'undo' }}</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ data.titulo }}</h2>
        <span class="modal-subtitle">{{ data.rotuloDocumento }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
    <p class="descricao-modal">
        Este pedido possui lançamentos ativos. Ao movê-lo, todos os lançamentos serão mantidos, exceto se você
        marcar a opção de desfazê-los abaixo. Tudo o que for desfeito continuará registrado no histórico do pedido.
    </p>

    <div class="pvcm-lista">
        @for (integracao of data.integracoes; track integracao.idVendaTipoIntegracao) {
            <div class="pvcm-item">
                <mat-checkbox
                    [checked]="isSelecionada(integracao)"
                    [disabled]="!integracao.isDesfazivel"
                    (change)="alternar(integracao)">
                    {{ rotulo(integracao) }}
                </mat-checkbox>
                @if (integracao.aviso) {
                    <span class="pvcm-aviso" [class.pvcm-aviso--bloqueio]="!integracao.isDesfazivel">{{ integracao.aviso }}</span>
                }
            </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button type="button" class="btn-primary" (click)="confirmar()">
        <mat-icon class="material-symbols-outlined">{{ data.isCancelar ? 'flag' : 'undo' }}</mat-icon>
        {{ data.isCancelar ? 'Cancelar pedido' : 'Mover' }}
    </button>
</mat-dialog-actions>
